import { useState, useRef } from 'react';
import { compressImage, fileToDataURL } from '../../utils/imageCompress';

export default function ImageUploader({ images, onChange, maxCount = 9 }) {
  const inputRef = useRef();
  const [compressing, setCompressing] = useState(false);

  const handleFiles = async (e) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;

    setCompressing(true);
    try {
      const results = await Promise.all(
        files.slice(0, maxCount - images.length).map(async (file) => {
          const compressed = await compressImage(file);
          const dataUrl = await fileToDataURL(compressed);
          return dataUrl;
        })
      );
      onChange([...images, ...results]);
    } finally {
      setCompressing(false);
      if (inputRef.current) inputRef.current.value = '';
    }
  };

  const remove = (index) => {
    onChange(images.filter((_, i) => i !== index));
  };

  return (
    <div className="image-uploader">
      <div className="image-preview-grid">
        {images.map((src, i) => (
          <div key={i} className="image-preview-item">
            <img src={src} alt="" />
            <button className="image-remove-btn" onClick={() => remove(i)}>×</button>
          </div>
        ))}
        {images.length < maxCount && (
          <button
            className="image-add-btn"
            onClick={() => inputRef.current?.click()}
            disabled={compressing}
          >
            {compressing ? (
              <span className="compress-spinner" />
            ) : (
              <>
                <span className="plus-icon">+</span>
                <span className="add-text">添加图片</span>
              </>
            )}
          </button>
        )}
      </div>
      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        multiple
        onChange={handleFiles}
        style={{ display: 'none' }}
      />
    </div>
  );
}
